export default "__VITE_ASSET__618e610c__"